package com.exura.features.firebase.data.mappers.versioning

import com.exura.features.firebase.data.mappers.SerializableMappers
import com.exura.features.firebase.data.remote.dto.versioning.VersionDto
import com.exura.features.firebase.domain.model.SerializableDomainModel
import com.exura.features.firebase.domain.model.versioning.Version
import com.exura.features.firebase.domain.model.versioning.VersionMetadata
import dev.gitlive.firebase.firestore.CollectionReference

class VersionMappers<T: SerializableDomainModel, M: VersionMetadata> : SerializableMappers<Version<T, M>, VersionDto<M>> {
    override fun toDto(model: Version<T, M>): VersionDto<M> = VersionDto(
        rootVersionId = model.rootVersionId,
        parentVersionId = model.parentVersionId,
        isActive = model.isActive,
        metadata = model.metadata,
        contentDocPrefix = model.contentDocPrefix.path.substringAfterLast("/"),
        createdAt = model.createdAt,
    )

    override fun toDomain(dto: VersionDto<M>, collection: CollectionReference?, id: String?): Version<T, M> = Version(
        firebaseDocId = id,
        firebaseDocPrefix = collection,
        rootVersionId = dto.rootVersionId,
        parentVersionId = dto.parentVersionId,
        isActive = dto.isActive,
        metadata = dto.metadata,
        contentDocPrefix = collection!!.parent!!.collection(dto.contentDocPrefix),
        createdAt = dto.createdAt,
    )
}
